@Config('ib-check-in-app')
class ibRouterConfig {
    constructor (
        private CheckinAppConstants,
        private CheckinRouterConstants,
        private $routeProvider,
        private $translateProvider,
        private localStorageServiceProvider,
        private $httpProvider,
        private $compileProvider,
        private $qProvider
    ) {}

    active = (): void => {
        this.$routeProvider
            .when('/ibcose', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbcoseRoute,
                controller: 'CheckInSearchController',
                controllerAs: 'searchCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-ancillaries').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-templates'));
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                        });
                    }]
                }
            }).when('/uncose', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbcoseRoute,
                controller: 'CheckInSearchController',
                controllerAs: 'searchCtrl',
                reloadOnSearch: false
            })
            .when('/ibcoac', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbcoacRoute,
                controller: 'FlightsPassengersController',
                controllerAs: 'flightsPasCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-web-ancillaries').then(() => {
                                $ocLazyLoad.load(angular.module('ib-web-ancillaries-templates'));
                                $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                                $ocLazyLoad.load(angular.module('ib-checkin-ancillaries-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ibcose2', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbcose2Route,
                controller: 'CheckInIbPlusController',
                controllerAs: 'checkIbPlusCtrl',
                reloadOnSearch: false
            })
            .when('/ibcoac2', {
                template: '<ib-checkin-apis></ib-checkin-apis>',
                reloadOnSearch: false
            })
            // .when('/ibcoac2', {
            //     templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbcoac2Route,
            //     controller: 'ApisFormController',
            //     controllerAs: 'apisCtrl',
            //     reloadOnSearch: false
            // })
            .when('/ckianc', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewCkiancRoute,
                controller: 'AncillariesController',
                controllerAs: 'ancillariesCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-web-libraries').then(() => {
                                $ocLazyLoad.load(angular.module('ib-web-ancillaries-templates'));
                                $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                                $ocLazyLoad.load(angular.module('ib-checkin-ancillaries-module'));
                                $ocLazyLoad.load(angular.module('ib-monetate-checkin-module'));
                                $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                                $ocLazyLoad.load(angular.module('ib-pmt-app'));
                                $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                                $ocLazyLoad.load(angular.module('ib-check-in-confirmation-module'));
                                $ocLazyLoad.load(angular.module('ib-breakdown-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ibpurc', {
                template: '<ib-checkin-payments />',
                reloadOnSearch: false,
                resolve: {
                    translateReady: ['$translate', function ($translate) {
                        return $translate.onReady();
                    }],
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-payments').then(() => {
                            $ocLazyLoad.load(angular.module('ib-checkin-payments-page-module'));
                            $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                            $ocLazyLoad.load(angular.module('ib-pmt-app'));
                            $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-check-in-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-breakdown-module'));
                        });
                    }]
                }
            })
            .when('/ibecbp', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbecbp,
                controller: 'BoardingCardsController',
                controllerAs: 'boardingCardsCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-boarding-cards').then(() => {
                                $ocLazyLoad.load(angular.module('ib-boarding-cards-module'));
                                $ocLazyLoad.load(angular.module('ib-checkin-biometric-boarding-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ckiancupp', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewCkiancupp,
                controller: 'UpgradeController',
                controllerAs: 'upgradeCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-upgrade').then(() => {
                                $ocLazyLoad.load(angular.module('ib-check-in-upgrade-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ibcocf-and-ibeccf', {
                template: '<ib-check-in-confirmation></ib-check-in-confirmation>',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-web-payments').then(() => {
                                $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                                $ocLazyLoad.load(angular.module('ib-pmt-app'));
                                $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                                $ocLazyLoad.load(angular.module('ib-check-in-confirmation-module'));
                                $ocLazyLoad.load(angular.module('ib-breakdown-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ibfnpa', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbfnpaRoute,
                controller: 'FlightNowController',
                controllerAs: 'fnPaCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-confirmation-pa').then(() => {
                                $ocLazyLoad.load(angular.module('ib-fly-now-confirmation-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ibfncopa', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbfncopaRoute,
                controller: 'FlyNowConfirmationPAController',
                controllerAs: 'fnCoPaCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-confirmation-pa').then(() => {
                                $ocLazyLoad.load(angular.module('ib-fly-now-confirmation-module'));
                            });
                        }
                    ]
                }
            })
            .when('/uncoac', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbdesRoute,
                controller: 'FlightsPassengerDesController',
                controllerAs: 'flightsPasDesCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-des-invoice').then(() => {
                                $ocLazyLoad.load(angular.module('ib-checkin-flights-des-invoice-module'));
                            });
                        }
                    ]
                }
            })
            .when('/ckbio', {
                templateUrl: this.CheckinRouterConstants.templatesRoute + this.CheckinRouterConstants.viewIbbioboaRoute,
                controller: 'CheckinBiometricBoardingController',
                controllerAs: 'bioBoardingCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: [
                        '$ocLazyLoad',
                        ($ocLazyLoad) => {
                            return import('@src/lazy-loading/ib-checkin-biometric').then(() => {
                                $ocLazyLoad.load(angular.module('ib-checkin-biometric-boarding-module'));
                            });
                        }
                    ]
                }
            })
            .when('/loading', {
                template: '<ib-loading-redirection></ib-loading-redirection>',
                reloadOnSearch: false
            })
            .otherwise({ redirectTo: '/ibcose' });

        //
        //Initialize the translation filter provider
        this.$translateProvider.useStaticFilesLoader({
            files: [
                { prefix: this.CheckinAppConstants.generalI18nRoute, suffix: '.json' },
                { prefix: this.CheckinAppConstants.i18nRoute, suffix: '.json' }
            ]
        });
        this.$translateProvider.useSanitizeValueStrategy('escaped');

        this.$httpProvider.interceptors.push('IbHttpInterceptor');
        this.$httpProvider.defaults.withCredentials = true;
        //Initialize the local storage provider
        this.localStorageServiceProvider.setPrefix('ib-check-in-app');
        this.localStorageServiceProvider.setStorageType('sessionStorage');
        this.$qProvider.errorOnUnhandledRejections(false);
        this.$compileProvider.debugInfoEnabled(false);
    };

    $onInit = this.active();
}
ibRouterConfig.$inject = [
    'CheckinAppConstants',
    'CheckinRouterConstants',
    '$routeProvider',
    '$translateProvider',
    'localStorageServiceProvider',
    '$httpProvider',
    '$compileProvider',
    '$qProvider'
];
